<template>
    <div class="card card-custom gutter-b">
        <div class="card-header border-0 py-6">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">ارسال اعلان جدید</span>
            </h3>
        </div>

        <div class="card-body">
            <form @submit.prevent="sendNotification">
                <div class="form-group">
                    <label>عنوان (اختیاری)</label>
                    <input type="text" v-model="form.title"
                        class="form-control form-control-lg form-control-solid h-50px"
                        placeholder="عنوان اعلان را وارد کنید" />
                </div>

                <div class="form-group">
                    <label>متن پیام <span class="text-danger">*</span></label>
                    <textarea v-model="form.message" class="form-control form-control-lg form-control-solid" rows="6"
                        placeholder="متن اعلان را بنویسید..." required></textarea>
                </div>

                <div class="form-group">
                    <label>نوع پیام <span class="text-danger">*</span></label>
                    <select v-model="form.type" class="form-control form-control-lg form-control-solid h-50px" required>
                        <option value="" disabled>یک نوع انتخاب کنید</option>
                        <option value="success">موفقیت</option>
                        <option value="info">اطلاع‌رسانی</option>
                        <option value="warning">هشدار</option>
                        <option value="error">خطا</option>
                        <option value="message">پیام</option>
                    </select>
                </div>

                <div class="form-group">
                    <label>اعلان عمومی (برای همهٔ کاربران)</label>
                    <div>
                        <span class="switch switch-primary">
                            <label>
                                <input type="checkbox" v-model="form.is_public" />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>

                <div v-if="!form.is_public" class="form-group">
                    <label>کاربران دریافت‌کننده <span class="text-danger">*</span></label>

                    <div class="mb-4">
                        <input ref="excelInput" type="file" accept=".xlsx,.xls,.csv" class="d-none"
                            @change="handleExcelFile" />
                        <button type="button" class="btn btn-light-primary font-weight-bold"
                            :disabled="importingExcel" @click="$refs.excelInput.click()">
                            <b-spinner v-if="importingExcel" small class="mr-2"></b-spinner>
                            {{ importingExcel ? 'در حال بارگذاری فایل...' : 'بارگذاری فایل اکسل' }}
                        </button>
                        <button type="button" class="btn btn-light font-weight-bold ml-2" @click="downloadSampleExcel">
                            دانلود فایل نمونه
                        </button>

                        <div v-if="excelResult" class="alert alert-custom mt-3 mb-0"
                            :class="excelResult.notFound.length || excelResult.invalid.length ? 'alert-light-warning' : 'alert-light-success'">
                            <div class="alert-text">
                                <div>{{ excelResult.added }} کاربر اضافه شد</div>
                                <details v-if="excelResult.notFound.length" class="mt-2">
                                    <summary class="cursor-pointer">{{ excelResult.notFound.length }} شماره بدون حساب</summary>
                                    <div class="excel-result-list mt-2" dir="ltr">{{ excelResult.notFound.join(", ") }}</div>
                                </details>
                                <details v-if="excelResult.invalid.length" class="mt-2">
                                    <summary class="cursor-pointer">{{ excelResult.invalid.length }} مقدار نامعتبر</summary>
                                    <div class="excel-result-list mt-2" dir="ltr">{{ excelResult.invalid.join(", ") }}</div>
                                </details>
                            </div>
                        </div>
                    </div>

                    <b-form-tags v-model="selectedUserTags" tag-variant="primary" tag-pills size="lg" placeholder=""
                        remove-on-delete class="mb-4"></b-form-tags>

                    <div class="row mb-3">
                        <div class="col-lg-6 mb-3 mb-lg-0">
                            <b-input-group>
                                <b-input-group-prepend is-text>
                                    <i class="flaticon2-user icon-md text-muted"></i>
                                </b-input-group-prepend>
                                <b-form-input v-model="searchName" placeholder="جستجو با نام یا نام خانوادگی..."
                                    class="form-control form-control-solid h-50px"
                                    @input="debouncedSearch"></b-form-input>
                            </b-input-group>
                        </div>

                        <div class="col-lg-6">
                            <b-input-group>
                                <b-input-group-prepend is-text>
                                    <i class="flaticon2-phone icon-md text-muted"></i>
                                </b-input-group-prepend>
                                <b-form-input v-model="searchCellphone"
                                    placeholder="جستجو با شماره موبایل (مثل 0918...)"
                                    class="form-control form-control-solid h-50px"
                                    @input="debouncedSearch"></b-form-input>
                            </b-input-group>
                        </div>
                    </div>

                    <div class="border rounded bg-light overflow-auto shadow-sm" style="max-height: 320px;"
                        @scroll.passive="handleScroll">
                        <div v-if="loadingUsers && userList.length === 0" class="text-center py-10">
                            <b-spinner variant="primary"></b-spinner>
                            <div class="mt-3 text-muted">در حال بارگذاری کاربران...</div>
                        </div>

                        <b-list-group flush>
                            <b-list-group-item v-for="user in userList" :key="user.id" button
                                class="d-flex align-items-center py-4 px-5 border-bottom"
                                :class="{ 'bg-hover-primary': !form.users.includes(user.id), 'bg-light-primary': form.users.includes(user.id) }"
                                @click="toggleUser(user.id)">
                                <div class="d-flex flex-column flex-grow-1">
                                    <span class="font-weight-bolder text-dark-75">
                                        {{ user.first_name }} {{ user.last_name || '' }}
                                    </span>
                                    <span class="text-dark-50 font-size-sm font-weight-bold">
                                        {{ user.cellphone }}
                                    </span>
                                </div>
                                <i v-if="form.users.includes(user.id)"
                                    class="flaticon2-check-mark text-success icon-lg"></i>
                            </b-list-group-item>

                            <b-list-group-item v-if="loadingUsers && userList.length > 0"
                                class="text-center py-5 bg-light">
                                <b-spinner small variant="primary"></b-spinner>
                                <span class="ml-3 text-muted">در حال بارگذاری...</span>
                            </b-list-group-item>

                            <b-list-group-item v-if="noMoreUsers && userList.length > 0"
                                class="text-center py-5 text-muted bg-light">
                                همه کاربران لود شدند
                            </b-list-group-item>
                        </b-list-group>
                    </div>

                    <div class="mt-4 text-right">
                        <small class="text-muted font-weight-bold">
                            {{ form.users.length }} کاربر انتخاب شده
                        </small>
                    </div>
                </div>

                <div class="form-group">
                    <label>روش ارسال <span class="text-danger">*</span></label>
                    <div class="checkbox-list">
                        <label class="checkbox checkbox-lg checkbox-outline checkbox-primary"
                            v-for="driver in availableDrivers" :key="driver.value">
                            <input type="checkbox" v-model="form.drivers" :value="driver.value" />
                            <span></span>
                            {{ driver.label }}
                        </label>
                    </div>
                    <span v-if="form.is_public" class="form-text text-muted">
                        سیستم در پنل همهٔ کاربران نمایش داده می‌شود. تلگرام و بله فقط به کاربرانی می‌رود که حسابشان وصل است.
                    </span>
                </div>

                <div class="text-right mt-10">
                    <button type="submit" class="btn btn-primary font-weight-bolder btn-lg px-10 py-4 shadow"
                        :disabled="sending || !isValid">
                        <b-spinner v-if="sending" small class="mr-3"></b-spinner>
                        {{ sending ? 'در حال ارسال اعلان...' : 'ارسال اعلان' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
    CREATE_ADMIN_NOTIFICATION,
    RESOLVE_ADMIN_NOTIFICATION_CELLPHONES
} from "@/core/services/store/admin/notifications.module";
import { FETCH_ADMIN_USERS } from "@/core/services/store/admin/users.module";
import _ from "lodash";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

const PUBLIC_DRIVERS = ["system", "telegram", "bale"];
const MAX_EXCEL_CELLPHONES = 5000;
const EXCEL_CELLPHONE_HEADER = "شماره موبایل";

export default {
    name: "AdminNotificationsCreate",

    data() {
        return {
            form: {
                title: "",
                message: "",
                type: "",
                is_public: false,
                users: [],
                drivers: []
            },
            searchName: "",
            searchCellphone: "",
            userList: [],
            userPage: 1,
            loadingUsers: false,
            noMoreUsers: false,
            sending: false,
            selectedUsersMap: {},
            importingExcel: false,
            excelResult: null,
            drivers: [
                { value: "system", label: "سیستم (دیتابیس)" },
                { value: "telegram", label: "تلگرام" },
                { value: "bale", label: "بله" },
                { value: "sms", label: "پیامک" }
            ]
        };
    },

    computed: {
        ...mapGetters(["adminUsers"]),

        availableDrivers() {
            return this.form.is_public
                ? this.drivers.filter(driver => PUBLIC_DRIVERS.includes(driver.value))
                : this.drivers;
        },

        selectedUserTags() {
            return this.form.users.map(id => {
                const user = this.selectedUsersMap[id];
                if (user) {
                    const name = `${user.first_name || ''} ${user.last_name || ''}`.trim();
                    return name ? `${name} (${user.cellphone})` : user.cellphone;
                }
                return `کاربر ${id}`;
            });
        },

        isValid() {
            return (
                this.form.message.trim() &&
                this.form.type &&
                (this.form.is_public || this.form.users.length > 0) &&
                this.form.drivers.length > 0
            );
        }
    },

    watch: {
        "form.is_public"(isPublic) {
            if (isPublic) {
                this.form.drivers = this.form.drivers.filter(driver => PUBLIC_DRIVERS.includes(driver));
            }
        }
    },

    mounted() {
        this.loadUsers();
    },

    methods: {
        debouncedSearch: _.debounce(function () {
            this.userPage = 1;
            this.userList = [];
            this.noMoreUsers = false;
            this.loadUsers();
        }, 500),

        async loadUsers() {
            if (this.loadingUsers || this.noMoreUsers) return;

            this.loadingUsers = true;

            let cellphone = undefined;
            if (this.searchCellphone) {
                cellphone = this.searchCellphone.replace(/^09/, "+989");
            }

            const payload = {
                name: this.searchName || undefined,
                cellphone: cellphone,
                page: this.userPage
            };

            try {
                await this.$store.dispatch(FETCH_ADMIN_USERS, payload);

                const newUsers = this.adminUsers || [];

                if (newUsers.length === 0) {
                    this.noMoreUsers = true;
                } else {
                    newUsers.forEach(user => {
                        this.$set(this.selectedUsersMap, user.id, user);
                    });

                    const existingIds = new Set(this.userList.map(u => u.id));
                    const filteredNewUsers = newUsers.filter(u => !existingIds.has(u.id));

                    if (this.userPage === 1) {
                        this.userList = filteredNewUsers;
                    } else {
                        this.userList = this.userList.concat(filteredNewUsers);
                    }
                    this.userPage++;
                }
            } catch (e) {
                //
            } finally {
                this.loadingUsers = false;
            }
        },

        handleScroll(e) {
            const element = e.target;
            const bottomOfElement = element.scrollHeight - element.scrollTop;
            const isNearBottom = bottomOfElement - element.clientHeight < 100;

            if (isNearBottom && !this.loadingUsers) {
                this.loadUsers();
            }
        },

        toggleUser(userId) {
            if (this.form.users.includes(userId)) {
                this.form.users = this.form.users.filter(id => id !== userId);
            } else {
                this.form.users.push(userId);
            }
        },

        getInitials(user) {
            const name = `${user.first_name || ''} ${user.last_name || ''}`.trim();
            if (name) {
                return name.split(" ").map(n => n[0]).join("").toUpperCase().substring(0, 2);
            }
            return user.cellphone?.slice(-2) || "??";
        },

        downloadSampleExcel() {
            const sheet = XLSX.utils.aoa_to_sheet([
                [EXCEL_CELLPHONE_HEADER, "شماره‌ها را از ردیف دوم در ستون A وارد کنید"]
            ]);
            sheet["!cols"] = [{ wch: 20 }, { wch: 50 }];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, sheet, "recipients");
            XLSX.writeFile(workbook, "notification-recipients-sample.xlsx");
        },

        readCellphones(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = event => {
                    try {
                        const data = event.target.result;
                        // Plain text keeps a CSV's leading zeros and its UTF-8 Persian digits.
                        const workbook = /\.csv$/i.test(file.name)
                            ? XLSX.read(new TextDecoder().decode(data), { type: "string", raw: true })
                            : XLSX.read(new Uint8Array(data), { type: "array" });
                        const sheet = workbook.Sheets[workbook.SheetNames[0]];
                        // Raw values, because formatted text turns a 12 digit number into 9.89123E+11.
                        const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, blankrows: false });

                        const values = rows.map(row => String(row[0] ?? "").trim());

                        if (values[0] === EXCEL_CELLPHONE_HEADER) {
                            values.shift();
                        }

                        resolve(values.filter(value => value !== ""));
                    } catch (e) {
                        reject(e);
                    }
                };
                reader.onerror = () => reject(reader.error);
                reader.readAsArrayBuffer(file);
            });
        },

        addResolvedUsers(users) {
            const selected = new Set(this.form.users);
            const newIds = users.map(user => user.id).filter(id => !selected.has(id));
            const resolved = {};

            users.forEach(user => {
                resolved[user.id] = user;
            });

            this.selectedUsersMap = { ...this.selectedUsersMap, ...resolved };
            this.form.users = this.form.users.concat(newIds);

            return newIds.length;
        },

        async handleExcelFile(event) {
            const file = event.target.files[0];
            // Lets the same file be chosen again.
            event.target.value = "";

            if (!file || this.importingExcel) return;

            this.importingExcel = true;
            this.excelResult = null;

            try {
                let cellphones;

                try {
                    if (!/\.(xlsx|xls|csv)$/i.test(file.name)) {
                        throw new Error("Unsupported file type");
                    }
                    cellphones = await this.readCellphones(file);
                } catch (e) {
                    this.showError("فایل قابل خواندن نیست. یک فایل معتبر xlsx، xls یا csv انتخاب کنید");
                    return;
                }

                if (cellphones.length === 0) {
                    this.showError("ستون اول فایل خالی است");
                    return;
                }

                if (cellphones.length > MAX_EXCEL_CELLPHONES) {
                    this.showError(`فایل ${cellphones.length} مقدار دارد و حداکثر ${MAX_EXCEL_CELLPHONES} مقدار مجاز است`);
                    return;
                }

                const result = await this.$store.dispatch(RESOLVE_ADMIN_NOTIFICATION_CELLPHONES, cellphones);

                this.excelResult = {
                    added: this.addResolvedUsers(result.users),
                    notFound: result.not_found,
                    invalid: result.invalid
                };
            } catch (response) {
                const data = response?.data;
                this.showError(data?.error || data?.message || "خطا در بررسی شماره‌های فایل");
            } finally {
                this.importingExcel = false;
            }
        },

        confirmPublicSend() {
            const channels = this.drivers
                .filter(driver => this.form.drivers.includes(driver.value))
                .map(driver => driver.label)
                .join("، ");

            return Swal.fire({
                title: "",
                text: `این اعلان برای همهٔ کاربران ارسال می‌شود. کانال‌های انتخابی: ${channels}. آیا از ارسال اطمینان دارید؟`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "بله",
                confirmButtonColor: "#4554a0",
                cancelButtonText: "خیر",
                cancelButtonColor: "#ed1c24",
                heightAuto: false
            }).then(result => result.isConfirmed);
        },

        async sendNotification() {
            if (!this.isValid || this.sending) return;

            if (this.form.is_public && !(await this.confirmPublicSend())) return;

            this.sending = true;

            const payload = {
                title: this.form.title || null,
                message: this.form.message,
                type: this.form.type,
                is_public: this.form.is_public,
                drivers: this.form.drivers
            };

            if (!this.form.is_public) {
                payload.users = this.form.users;
            }

            try {
                await this.$store.dispatch(CREATE_ADMIN_NOTIFICATION, payload);
                this.$bvToast.toast("اعلان با موفقیت ارسال شد", {
                    title: "موفقیت",
                    variant: "success",
                    solid: true
                });
                this.$router.push({ name: "admin-notifications-index" });
            } catch (error) {
                this.$bvToast.toast("خطا در ارسال اعلان", {
                    title: "خطا",
                    variant: "danger",
                    solid: true
                });
            } finally {
                this.sending = false;
            }
        }
    }
};
</script>

<style scoped>
.checkbox-lg .checkbox>span {
    width: 28px;
    height: 28px;
}

.checkbox-lg .checkbox>input:checked~span {
    background-color: #4F46E5;
    border-color: #4F46E5;
}

.cursor-pointer {
    cursor: pointer;
}

.bg-hover-primary:hover {
    background-color: rgba(79, 70, 229, 0.05) !important;
}

.bg-light-primary {
    background-color: rgba(79, 70, 229, 0.1) !important;
}

.text-dark-50 {
    color: #7E8299 !important;
}

.excel-result-list {
    max-height: 160px;
    overflow: auto;
    text-align: left;
    word-break: break-word;
}
</style>